<template>
  <div v-if="finalMessage" class="popup-container" id="popup-container">
    <div class="popup w-1/4 text-gray-300">
      <h2>{{ finalMessage }}</h2>
      <h3 v-show="status === 'lose'">...the word was: {{ word }}</h3>
      <button @click="reset" class="mt-16 rounded-lg p-2 bg-gray-900">Play Again</button>
      <span> <router-link :to="{ name: 'Dashboard' }" class="mt-16 text-3xl ml-32 ">X</router-link></span>
    </div>
  </div>
</template>

<script>
import { computed } from "vue"
export default {
  props: {
    status: { type: String, default: "" },
    word: { type: String, default: "" },
  },
  setup(props, { emit }) {
    const finalMessage = computed(() => {
      if (props.status === "win") return "Congratulations! You won! 😃"
      if (props.status === "lose") return "Unfortunately you lost. 😕"
      return ""
    })
    const reset = () => emit("reset")
    return { finalMessage, reset }
  },
}
</script>
<style scoped>
.popup-container {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  /* display: none; */
  align-items: center;
  justify-content: center;
}

.popup {
  background: #164e63;
  border-radius: 5px;
  box-shadow: 0 15px 10px 3px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
}

.popup button:active {
  transform: scale(0.98);
}

.popup button:focus {
  outline: 0;
}
</style>
